import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface AbcLetContext<T> {
  abcLet: T;
}

@Directive({
    selector: '[abcLet]',
    standalone: false
})
export class AbcLetDirective<T> {
  private _context: AbcLetContext<T> = { abcLet: null };

  constructor(_viewContainer: ViewContainerRef, _templateRef: TemplateRef<AbcLetContext<T>>) {
    _viewContainer.createEmbeddedView(_templateRef, this._context);
  }

  @Input()
  set abcLet(value: T) {
    this._context.abcLet = value;
  }
}

@Directive({
  selector: '[abcTemplate]',
  standalone: true,
})
export class AbcTemplateDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
